<template>
  <li>
    <a :href="'#'+marker.id" v-scroll-to="'#'+marker.id" @click.prevent="scrollToMarker">
    <div class="bullet" :style="{backgroundColor:marker.color}" ></div>
      {{marker.name}}
    </a>
  </li>
</template>
<script>

export default {
  name: 'CategoryListItem',
  components : {
  },
  data () {
    return {
    }
  },
  methods : {
/*    scrollToMarker(){
      //needs reinstated without event bus
      EventBus.$emit('makeVisibleCat', this.catIndex);
      setTimeout(
          ()=> { // it's that scope thing again...
              EventBus.$emit('sctm', this.marker.id);
          },
          100
      )
    }*/
  },
  props :['marker', 'catIndex'],
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/CategoryListItem.vue